function initVerdi(root=document){
  root.querySelectorAll('[data-product-section]').forEach(section=>{
    if(section.dataset.initialized)return;
    section.dataset.initialized='true';
    const selector=section.querySelector('[data-variant-select]');
    const button=section.querySelector('[data-add-button]');
    const price=section.querySelector('[data-product-price]');
    const quantity=section.querySelector('[data-product-quantity]');
    if(!selector||!button)return;
    selector.addEventListener('change',()=>{
      const option=selector.selectedOptions[0];
      if(!option)return;
      const available=option.dataset.available==='true';
      button.disabled=!available;
      button.textContent=available?button.dataset.addText:button.dataset.soldText;
      price.replaceChildren(document.createTextNode(option.dataset.price));
      if(option.dataset.compare){const compare=document.createElement('s');compare.textContent=option.dataset.compare;price.append(' ',compare);}
      quantity.min=option.dataset.min||'1';
      quantity.step=option.dataset.increment||'1';
      if(option.dataset.max)quantity.max=option.dataset.max;else quantity.removeAttribute('max');
      quantity.value=quantity.min;
      const url=new URL(window.location.href);url.searchParams.set('variant',option.value);window.history.replaceState({},'',url);
      const media=section.querySelector('[data-media-id="'+option.dataset.mediaId+'"]');
      if(media)media.scrollIntoView({block:'nearest',inline:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    });
  });
}
initVerdi();
document.addEventListener('shopify:section:load',event=>initVerdi(event.target));
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.mobile-nav[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});
document.addEventListener('click',event=>{document.querySelectorAll('.mobile-nav[open]').forEach(menu=>{if(!menu.contains(event.target)||event.target.closest('a'))menu.open=false;});});
